import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function useWindowWidth() {
  const [w, setW] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  React.useEffect(() => {
    const onResize = () => setW(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return w;
}



export default function BookCard(props) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [hoveredCafeLink, setHoveredCafeLink] = useState(null);
  const winW = useWindowWidth();
  const isPhone = winW <= 480;
  // Джерело даних: або окремі пропси, або об’єкт-шаблон (tpl/template/item/…)
  const src =
    props.tpl ||
    props.template ||
    props.t ||
    props.book ||
    props.item ||
    {};

  // Пріоритет: явні пропси > з об’єкта-шаблона > дефолти
  const isbn        = props.isbn        ?? src.isbn        ?? '';
  const title       = props.title       ?? src.title       ?? 'Без назви';
  const author      = props.author      ?? src.author      ?? '';
  const coverUrl    = props.coverUrl    ?? src.coverUrl    ?? src.cover ?? src.imageUrl ?? src.thumbnailUrl ?? '';
  const borrowPrice = props.borrowPrice ?? src.borrowPrice ?? src.priceBorrow ?? src.price ?? null;
  const borrowCount = props.borrowCount ?? src.borrowCount ?? 0;
  const locationFallback =
    [src.cafeName, src.cafeAddress].filter(Boolean).join(', ') || src.location || '';
  const availabilityText = props.availabilityText ?? src.availabilityText ?? locationFallback;
  const showFullTitleOnHover = typeof title === 'string' && title.length > 36;
  const availabilityCafes = Array.isArray(props.availabilityCafes)
    ? props.availabilityCafes
    : Array.isArray(src.availabilityCafes)
      ? src.availabilityCafes
      : [];

  const cardStyle = {
    width: '100%',
    boxSizing: 'border-box',          // ← додали, щоб padding/border входили у ширину
    border: '1px solid #E8E5DE',
    borderRadius: 12,
    padding: 12,
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    minHeight: 320,
    cursor: 'pointer',
    boxShadow: hovered
      ? '0 10px 24px rgba(15, 23, 42, 0.10), 0 4px 10px rgba(15, 23, 42, 0.07)'
      : '0 4px 12px rgba(0, 0, 0, 0.06)',
    transform: hovered ? 'translateY(-4px) scale(1.005)' : 'translateY(0) scale(1)',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease'
  };




  const imageWrap = {
    height: isPhone ? 200 : 260,
    aspectRatio: '2 / 3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    background: 'transparent'
  };

  const handleClick = (e) => {
    if (e?.target?.closest?.('a,button')) return;
    if (isbn) navigate(`/book/${isbn}`);
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={cardStyle}
      title={isbn ? 'Переглянути сторінку книги' : ''}
    >
      <div style={imageWrap}>
        <img
          src={coverUrl || 'https://placehold.co/180x260?text=No+cover'}
          alt={title}
          loading="lazy"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'center'
          }}
        />
      </div>

      <div
        title={showFullTitleOnHover ? title : undefined}
        style={{
          fontWeight: 700,
          fontSize: isPhone ? 15 : 16,
          lineHeight: '1.25em',
          color: '#1f2937',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          minHeight: '2.5em',
        }}
      >
        {title}
      </div>
      <div style={{ color: '#6b7280', fontSize: 13 }}>{author}</div>

      {/* Нижній блок завжди біля дна */}
      <div style={{ marginTop: 'auto' }}>
        <div style={{ fontWeight: 700, fontSize: 16 }}>
          {borrowPrice ?? '—'} монет
        </div>
        <div style={{ color: '#6b7280', fontSize: 12, marginTop: 6 }}>
          прочитано: {borrowCount ?? 0} раз(ів)
        </div>
        {availabilityCafes.length > 0 ? (
          <div style={{ color: '#4b5563', fontSize: 12, marginTop: 6, lineHeight: 1.35 }}>
            {availabilityCafes.slice(0, 2).map((c, idx) => (
              <React.Fragment key={`${c.name || 'cafe'}-${c.address || ''}-${idx}`}>
                <Link
                  to={`/cafe/${encodeURIComponent(c.name || '')}`}
                  onClick={(e) => e.stopPropagation()}
                  onMouseEnter={() => setHoveredCafeLink(idx)}
                  onMouseLeave={() => setHoveredCafeLink(null)}
                  style={{
                    color: hoveredCafeLink === idx ? '#14532d' : '#6b7280',
                    textDecoration: 'underline',
                  }}
                  title="Перейти на сторінку кав'ярні"
                >
                  {[c.name, c.address].filter(Boolean).join(', ')}
                </Link>
                {idx < Math.min(availabilityCafes.length, 2) - 1 ? '; ' : ''}
              </React.Fragment>
            ))}
            {availabilityCafes.length > 2 ? `; і ще ${availabilityCafes.length - 2}` : ''}
          </div>
        ) : availabilityText ? (
          <div style={{ color: '#4b5563', fontSize: 12, marginTop: 6 }}>
            {availabilityText}
          </div>
        ) : null}
      </div>
    </div>
  );
}
